export enum TradingAlertStatus {
    ACTIVE = "ACTIVE",
    MATCHED = "MATCHED",
    NOTIFIED = "NOTIFIED"
}
